module.exports = __webpack_public_path__ + "static/Meet the Doctor-d5b1e3d354477b923629eec49265b367.png";